<template>
  <div class="next-maintenance-section"
    :class="borderHandler(nextMaintenance.status)">
    <div class="next-maintenance-section__title">
      <strong>
        {{ $t('engineering.commutator-maintenance.next-maintenance') }}
      </strong>
    </div>
    <div class="next-maintenance-section__status">
      <div>
        <div class="text-center next-maintenance-section__title--bold">
          {{ $t('general.status')}}
        </div>
        <div
          class="next-maintenance-section__status-box"
          :class="backgroundHandler(nextMaintenance.status)"
        >
          {{ statusHandler(nextMaintenance.status) }}
        </div>
      </div>
      <div>
        <div class="text-center next-maintenance-section__title--bold">
          {{ $t('engineering.commutator-maintenance.expected-date') }}
        </div>
        <div class="next-maintenance-section__status-box"
          :class="backgroundHandler(nextMaintenance.status)"
        >
          <date-time-label
            v-if="nextMaintenance.expectedDate"
            :value="nextMaintenance.expectedDate"
            :format="dateLabelFormat"
          />
          <span v-else>-</span>
        </div>
      </div>
    </div>
    <div class="next-maintenance-section__reference mt-3">
      <div class="next-maintenance-section__reference-title next-maintenance-section__title--bold">
        {{ $t('general.reference') }}
      </div>
      <div v-if="hasReferences"
         class="next-maintenance-section__references-wrapper"
      >
        <span
          v-for="(reference, index) in nextMaintenance.references"
          :key="index"
        >
          <strong
            class="next-maintenance-section__item"
            v-if="!isI2PUReference(reference)"
          >
            {{ referenceTitleHandler(reference) }}
          </strong>
          <i2pu
            v-else
            class="ml-1"
          />
        </span>
      </div>
      <strong v-else>-</strong>
    </div>
  </div>
</template>

<script>
import { MaintenanceStatus, CommutatorMaintenanceReferences } from 'sigma-mappings';
import DateTimeLabel from '@/components/globals/DateTimeLabel';
import enumFilter from '@/filters/enumFilter';
import I2pu from '@/domain/components/installation/engineering/commutatorMaintenance/I2pu';
import { formats } from '@/constants/localizer';

export default {
  name: 'NextMaintenanceSection',
  props: {
    nextMaintenance: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DateTimeLabel,
    I2pu,
  },
  computed: {
    hasReferences() {
      return this.nextMaintenance?.references?.length;
    },
  },
  data: () => ({
    dateLabelFormat: formats.DATE_SHORT,
  }),
  methods: {
    enumFilter,
    statusHandler(status) {
      return status ? this.enumFilter(status, 'engineering.maintenance-status') : '-';
    },
    referenceTitleHandler(reference) {
      const references = {
        [CommutatorMaintenanceReferences.SERVICE_TIME]: this.$t('engineering.commutator-maintenance.service-time'),
        [CommutatorMaintenanceReferences.COMMUTATIONS]: this.$t('engineering.commutator-maintenance.commutations'),
      };
      return references[reference];
    },
    isI2PUReference(reference) {
      return reference === CommutatorMaintenanceReferences.I2PU;
    },
    backgroundHandler(status) {
      const backgroundColors = {
        [MaintenanceStatus.IN_DAY]: 'next-maintenance-section__status-box--in-day',
        [MaintenanceStatus.DELAYED]: 'next-maintenance-section__status-box--delayed',
        [MaintenanceStatus.IMMINENT]: 'next-maintenance-section__status-box--imminent',
      };
      return backgroundColors[status] || 'next-maintenance-section__status-box--none';
    },
    borderHandler(status) {
      const borderColors = {
        [MaintenanceStatus.IN_DAY]: 'next-maintenance-section__border--in-day',
        [MaintenanceStatus.DELAYED]: 'next-maintenance-section__border--delayed',
        [MaintenanceStatus.IMMINENT]: 'next-maintenance-section__border--imminent',
      };
      return borderColors[status] || 'next-maintenance-section__border--in-day';
    },
  },
};
</script>
<style lang="sass" scoped>
  .next-maintenance-section
    position: relative
    display: flex
    flex-direction: column
    justify-content: space-around
    height: 100%
    width: 100%
    border-radius: 3px
    &__border
      &--in-day
        border: 1.3px solid var(--color-tooltip-border)
      &--imminent
        border: 1.3px solid var(--color-warning)
      &--delayed
        box-shadow: 0 0 3px var(--color-danger-light),
        inset 0 0 3px var(--color-danger-light) !important
    &__item
      display: inline-block
    &__title
      text-align: center
      height: 35px
      &--bold
        font-weight: 600
    &__status
      display: flex
      flex-direction: row
      flex-wrap: nowrap
      justify-content: space-around
    &__status-box
      display: flex
      justify-content: center
      align-items: center
      width: 125px
      height: 50px
      font-size: 1.2em
      border-radius: 2px
      color: white
      font-weight: bold
      &--none
        color: var(--font-color-primary)
        background: var(--color-background-dark)
      &--in-day
        background: var(--color-primary)
      &--imminent
        background: var(--color-warning)
      &--delayed
        background: var(--color-danger)
    &__reference
      display: flex
      justify-content: center
      flex-wrap: wrap
    &__references-wrapper
      display: flex
      flex-wrap: wrap
      max-width: 90%
      justify-content: center
      align-items: center
      font-size: 1.2rem
      > span:not(:last-child)
        &::after
          font-weight: bold
          content: ','
          margin-right: 2px
    &__reference-title
      width: 100%
      margin-top: 5px
      text-align: center
</style>

